module.exports = __webpack_public_path__ + "img/m_bg_01.63ff617f.svg";